import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { ensureKnown, submitFeedback } from '../../store/knownDataSlice';
import QueryDetails from '../parts/QueryDetails';
import JobFeedbackView from '../parts/JobFeedbackView';
import SendFeedback from '../parts/SendFeedback';
import DriverNotes from '../parts/DriverNotes';
import FoodPackages from '../parts/FoodPackages';




function JobView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);



    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Töö</h1>
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

                <FoodPackages id={id} />

                <JobFeedbackView id={id} />

                <SendFeedback id={id} />

            </div>

        </div>
    );
};

export default JobView;